export default __webpack_public_path__ + "static/media/s5.1e2c59ee.jpg";